export class SaveDTO
{
    constructor()
        {
            this.English = "Save";
            this.Arabic = "حفظ";
        }
    English:string 
    Arabic:string 
}